/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventTooltipsActionsTooltip
 */
export interface IntegrationEventTooltipsActionsTooltip {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventTooltipsActionsTooltip
     */
    type?: IntegrationEventTooltipsActionsTooltipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventTooltipsActionsTooltip
     */
    message?: string;
}


/**
 * @export
 */
export const IntegrationEventTooltipsActionsTooltipTypeEnum = {
    Info: 'info',
    Error: 'error',
    Confirm: 'confirm',
    Revert: 'revert'
} as const;
export type IntegrationEventTooltipsActionsTooltipTypeEnum = typeof IntegrationEventTooltipsActionsTooltipTypeEnum[keyof typeof IntegrationEventTooltipsActionsTooltipTypeEnum];


/**
 * Check if a given object implements the IntegrationEventTooltipsActionsTooltip interface.
 */
export function instanceOfIntegrationEventTooltipsActionsTooltip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventTooltipsActionsTooltipFromJSON(json: any): IntegrationEventTooltipsActionsTooltip {
    return IntegrationEventTooltipsActionsTooltipFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsActionsTooltipFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltipsActionsTooltip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function IntegrationEventTooltipsActionsTooltipToJSON(value?: IntegrationEventTooltipsActionsTooltip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'message': value.message,
    };
}

